import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";

const links = [
  { label: "Platform", to: "/#pillars" },
  { label: "Product", to: "/product" },
  { label: "Demo", to: "/#demo" },
  { label: "Partners", to: "/#partners" },
  { label: "Contact", to: "/#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-header" data-testid="navbar">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-6 sm:px-10">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src="/logo-mark.png" alt="DotIQ logo" className="h-7 w-7" />
          <span className="font-display text-lg font-medium tracking-tight">DotIQ</span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/apply"
            data-testid="nav-apply-button"
            className="group inline-flex items-center gap-2 border border-white/15 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-signal hover:bg-signal/10"
          >
            Apply as Design Partner
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="glass-header border-t border-white/10 md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {links.map((l) => (
                <Link
                  key={l.label}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="py-3 font-mono text-xs uppercase tracking-[0.2em] text-white/60"
                >
                  {l.label}
                </Link>
              ))}
              <Link
                to="/apply"
                onClick={() => setOpen(false)}
                className="mt-4 inline-flex items-center justify-center gap-2 border border-signal px-5 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white"
                data-testid="nav-mobile-apply-button"
              >
                Apply as Design Partner
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
